import initState, { userProfileData } from './state';

import translatePermissions from '@/services/shared/permissions/permissions.translator';

import {
  isObject,
  isString
} from '@/utils';

/**
 * @summary Clear the user's profile information
 */
export const purgeUserProfile = (state) => {
  Object.assign(state, userProfileData());
};

/**
 * @summary Set user state from claims
 * @param {object} profile
 */
export const setUserProfile = (state, {
  agencyId,
  hsUserType,
  hsUserName,
  exp,
  ...rest
} = {}) => {
  state.isAuthenticated = true;
  state.agencyId = agencyId;
  state.userType = hsUserType;
  state.initials = hsUserName;
  state.exp = exp;

  const {
    cmsPermissions,
    permCMS0,
    permCMS1
  } = rest;

  const assignPermissions = assign(state.permissions);

  if (isString(permCMS0)) {
    assignPermissions({
      agency: translatePermissions({ permCMS0 })
    });
  }

  if (isString(permCMS1)) {
    assignPermissions({
      office: translatePermissions({ permCMS1 })
    });
  }

  if (isObject(cmsPermissions)) {
    state.cmsFlags = cmsPermissions;
  }
};

export const setUserResources = (state, { urls, products }) => {
  state.resources = urls;
  state.products = products;
};

/**
 * @summary Add the current renewal task to the store for tracking
 * @param {object} task The current setTimeout task for session renewal
 */
export const trackRenewalTask = (state, task) => {
  state.renewalTask = task;
};

/**
 * @summary Clear the current task and reset its state field
 */
export const clearRenewalTask = (state) => {
  clearTimeout(state.renewalTask);
  state.renewalTask = null;
};

export const resetState = (state) => {
  Object.assign(state, initState());
};

/* Helpers */
function assign (target) {
  return function (addition) {
    Object.assign(target, addition);
  };
}
